import VotingQuestion from './VotingQuestion'

export default VotingQuestion
